<template>
  <div class="about-page">
    <header class="about-head">
      <div class="sec-inner">
        <div class="about-head-grid">
          <div>
            <div class="sec-eyebrow">关于我</div>
            <h1 class="about-title">{{ profile.name }}</h1>
            <div class="about-headline">{{ profile.headline }}</div>
          </div>
          <div class="about-avatar">
            <img
              v-if="avatar && !avatarBroken"
              :src="avatar"
              alt="穆雄雄"
              data-zoom
              @error="avatarBroken = true"
            />
            <span v-else class="about-avatar-text">
              {{ profile.name.charAt(0) }}
            </span>
          </div>
        </div>
        <p class="about-intro">{{ profile.intro }}</p>
      </div>
    </header>

    <section class="sec sec-alt">
      <div class="sec-inner">
        <div class="sec-eyebrow">履历</div>
        <h2 class="sec-title">职业经历</h2>
        <div class="timeline">
          <div class="tl-item" v-for="item in timeline" :key="item.period">
            <div class="tl-period">{{ item.period }}</div>
            <div class="tl-body">
              <h3 class="tl-title">{{ item.title }}</h3>
              <p class="tl-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
        <router-link class="story-link" to="/story">
          阅读完整故事 &rarr;
        </router-link>
      </div>
    </section>

    <HonorSection />

    <section class="sec sec-alt">
      <div class="sec-inner">
        <div class="sec-eyebrow">写作</div>
        <h2 class="sec-title">十年技术写作</h2>
        <p class="sec-sub">
          {{ csdn.joined }}注册，持续更新至今。从实战问题、源码分析到任教时整理的讲义，均有沉淀。
        </p>
        <div class="csdn-stats">
          <div class="cs" v-for="s in csdn.stats" :key="s.label">
            <div class="cs-value">{{ s.value }}</div>
            <div class="cs-label">{{ s.label }}</div>
          </div>
        </div>
        <div class="csdn-badges">
          <span v-for="b in csdn.badges" :key="b">{{ b }}</span>
        </div>
        <div class="cols-list">
          <span class="col-item" v-for="c in csdn.columns" :key="c.name">
            {{ c.name }}<em>{{ c.count }}</em>
          </span>
        </div>
        <a class="csdn-go" :href="csdn.link" target="_blank" rel="noopener">
          去 CSDN 看全部文章 &rarr;
        </a>
      </div>
    </section>

    <section class="sec">
      <div class="sec-inner">
        <div class="sec-eyebrow">公司</div>
        <h2 class="sec-title">{{ company.name }}</h2>
        <p class="sec-sub">{{ company.desc }}</p>
        <div class="facts">
          <div class="fact" v-for="f in company.facts" :key="f.label">
            <div class="fact-value">{{ f.value }}</div>
            <div class="fact-label">{{ f.label }}</div>
          </div>
        </div>
        <ul class="honor-list">
          <li v-for="h in company.honors" :key="h">{{ h }}</li>
        </ul>
        <a class="csdn-go" :href="company.site" target="_blank" rel="noopener">
          公司官网 sdruizer.com &rarr;
        </a>
      </div>
    </section>

    <section class="sec sec-alt">
      <div class="sec-inner">
        <div class="sec-eyebrow">公众号与社群</div>
        <h2 class="sec-title">公众号与长护社群</h2>
        <p class="sec-sub">
          一个侧重技术与长护险信息化，一个专注长护险政策解读与每日简报，扫码即可关注。
        </p>
        <div class="mp-list">
          <div class="mp" v-for="a in accounts" :key="a.name">
            <div class="mp-left">
              <div class="mp-top">
                <img class="mp-avatar" :src="a.avatar" :alt="a.name" data-zoom />
                <div>
                  <div class="mp-name">{{ a.name }}</div>
                  <div class="mp-sub">{{ a.location }} · {{ a.posts }}</div>
                </div>
              </div>
              <p class="mp-desc">{{ a.desc }}</p>
              <div class="mp-fans"><strong>{{ a.followers }}</strong> 关注</div>
            </div>
            <div class="mp-right">
              <img class="mp-qr" :src="a.qrcode" :alt="a.name + ' 二维码'" data-zoom />
              <div class="mp-qr-tip">微信扫码关注</div>
            </div>
          </div>
        </div>
        <div class="chx-community">
          <p class="chx-intro">{{ chxCommunity.intro }}</p>
          <div class="chx-facts">
            <div class="cf" v-for="f in chxCommunity.facts" :key="f.label">
              <div class="cf-value">{{ f.value }}</div>
              <div class="cf-label">{{ f.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="sec">
      <div class="sec-inner">
        <div class="sec-eyebrow">联系</div>
        <h2 class="sec-title">联系方式</h2>
        <div class="contact-rows">
          <a class="crow" :href="'tel:' + profile.phone">
            <span class="crow-k">手机 / 微信</span>
            <span class="crow-v strong">{{ profile.phone }}</span>
          </a>
          <a class="crow" :href="'mailto:' + profile.email">
            <span class="crow-k">邮箱</span>
            <span class="crow-v">{{ profile.email }}</span>
          </a>
          <a class="crow" :href="profile.csdn" target="_blank" rel="noopener">
            <span class="crow-k">CSDN</span>
            <span class="crow-v">blog.csdn.net/qq_34137397 &rarr;</span>
          </a>
          <a class="crow" :href="profile.github" target="_blank" rel="noopener">
            <span class="crow-k">GitHub</span>
            <span class="crow-v">github.com/mxx1111 &rarr;</span>
          </a>
          <a class="crow" :href="profile.gitee" target="_blank" rel="noopener">
            <span class="crow-k">Gitee</span>
            <span class="crow-v">gitee.com/muxiongxiong &rarr;</span>
          </a>
          <div class="crow static" v-if="accountNames">
            <span class="crow-k">微信公众号</span>
            <span class="crow-v">{{ accountNames }}</span>
          </div>
          <div class="crow static">
            <span class="crow-k">所在地</span>
            <span class="crow-v">{{ profile.location }}</span>
          </div>
        </div>
        <p class="contact-note">{{ profile.motto }}。</p>
      </div>
    </section>
  </div>
</template>

<script>
import {
  profile,
  timeline,
  accounts,
  company,
  writing,
  chxCommunity
} from "@/assets/js/profile";

import HonorSection from "@/views/home/components/HonorSection";

export default {
  name: "About",
  components: { HonorSection },
  data() {
    // 图床域名 blogobs.88688.team 目前解析不了，头像挂了就退回文字头像
    return {
      chxCommunity,
      profile,
      timeline,
      accounts,
      company,
      csdn: writing.csdn,
      avatarBroken: false
    };
  },
  metaInfo: {
    title: "关于我 - 穆雄雄",
    meta: [
      {
        name: "keywords",
        content:
          "穆雄雄,muxiongxiong,个人简介,履历,CSDN,山东睿泽网络科技,长护险信息化,慢病管理"
      },
      {
        name: "description",
        content:
          "穆雄雄，山西吕梁人，现在济南。从酒店前台自学编程入行，在学校教了五年计算机，之后转做研发，现在在山东睿泽做医疗与医保信息化。CSDN 十年 1345 篇原创，累计访问 348 万。"
      }
    ]
  },
  computed: {
    webSite() {
      const w = this.$store.state.blogInfo.webSite || {};
      // 库里存的还是旧的 GitHub 账号，以 profile.js 为准
      return Object.assign({}, w, { github: profile.github || w.github });
    },
    accountNames() {
      return this.accounts.map(a => a.name).join("、");
    },
    avatar() {
      // 库里存的 blogobs.88688.team 已无 DNS 解析，优先用自托管头像
      return profile.avatar || this.webSite.authorAvatar;
    }
  }
};
</script>

<style scoped>
.about-page {
  background: var(--bg);
}
.about-head {
  padding: 120px 24px 56px;
  border-bottom: 1px solid var(--border-soft);
}
.about-head-grid {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.about-title {
  font-size: 52px;
  font-weight: 600;
  letter-spacing: -1.5px;
  color: var(--ink);
  margin: 0 0 12px;
  line-height: 1.1;
}
.about-headline {
  font-size: 19px;
  color: var(--ink-mid);
}
.about-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.about-avatar img {
  cursor: zoom-in;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.about-avatar-text {
  font-size: 34px;
  font-weight: 600;
  color: var(--accent);
}
.about-intro {
  font-size: 15.5px;
  line-height: 2;
  color: var(--ink-soft);
  max-width: 680px;
  margin: 26px 0 0;
}
.timeline {
  margin-top: 40px;
  border-top: 1px solid var(--border);
}
.tl-item {
  display: flex;
  flex-wrap: wrap;
  padding: 30px 0;
  border-bottom: 1px solid var(--border);
}
.tl-period {
  flex: 0 0 200px;
  font-size: 14px;
  color: var(--accent);
  padding-top: 3px;
}
.tl-body {
  flex: 1 1 420px;
  min-width: 280px;
}
.tl-title {
  font-size: 18.5px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 10px;
}
.tl-desc {
  font-size: 15px;
  line-height: 1.95;
  color: var(--ink-soft);
  margin: 0;
}
.contact-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 32px;
}
.contact-list a,
.contact-list span {
  font-size: 15px;
  color: var(--ink-mid);
  margin: 0 28px 12px 0;
}
.contact-list a:hover {
  color: var(--accent);
}
.contact-note {
  font-size: 14px;
  color: var(--ink-faint);
  margin: 14px 0 0;
}

@media (max-width: 760px) {
  .about-head {
    padding: 92px 20px 42px;
  }
  .about-title {
    font-size: 34px;
  }
  .about-headline {
    font-size: 16px;
  }
  .tl-period {
    flex: 0 0 100%;
    margin-bottom: 8px;
  }
}

/* CSDN 与公司 */
.csdn-stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  padding-top: 26px;
  border-top: 1px solid var(--border);
}
.cs {
  flex: 1 1 140px;
  min-width: 120px;
  margin-bottom: 12px;
}
.cs-value {
  font-size: 30px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.8px;
}
.cs-label {
  font-size: 13px;
  color: var(--ink-soft);
  margin-top: 5px;
}
.csdn-badges {
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
}
.csdn-badges span {
  font-size: 12.5px;
  color: var(--accent-deep);
  background: var(--accent-wash);
  border-radius: 6px;
  padding: 5px 12px;
  margin: 0 8px 8px 0;
}
.cols-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
.col-item {
  font-size: 13.5px;
  color: var(--ink-mid);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 6px 14px;
  margin: 0 9px 9px 0;
}
.col-item em {
  font-style: normal;
  font-size: 12px;
  color: var(--ink-faint);
  margin-left: 8px;
}
.csdn-go {
  display: inline-block;
  margin-top: 20px;
  font-size: 15px;
  font-weight: 500;
  color: var(--accent);
}
.csdn-go:hover {
  color: var(--accent-deep);
}
.facts {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  padding: 24px 0;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}
.fact {
  flex: 1 1 150px;
  min-width: 120px;
  margin-bottom: 10px;
}
.fact-value {
  font-size: 28px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.8px;
}
.fact-label {
  font-size: 13px;
  color: var(--ink-soft);
  margin-top: 5px;
}
.honor-list {
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
}
.honor-list li {
  font-size: 14.5px;
  line-height: 1.95;
  color: var(--ink-mid);
  padding-left: 16px;
  position: relative;
}
.honor-list li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent);
}

/* 联系方式 */
.contact-rows {
  margin-top: 30px;
  border-top: 1px solid var(--border);
  max-width: 560px;
}
.crow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 4px;
  border-bottom: 1px solid var(--border);
  transition: padding-left 0.18s ease;
}
.crow:not(.static):hover {
  padding-left: 10px;
}
.crow-k {
  font-size: 14.5px;
  font-weight: 500;
  color: var(--ink);
}
.crow-v {
  font-size: 14px;
  color: var(--ink-soft);
  text-align: right;
}
.crow-v.strong {
  font-size: 16px;
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.4px;
}
.crow:not(.static):hover .crow-v {
  color: var(--accent);
}

/* 公众号 */
.mp-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 18px;
  margin-top: 30px;
}
.mp {
  display: flex;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px;
}
.mp-left {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}
.mp-top {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.mp-avatar {
  cursor: zoom-in;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid var(--border);
  margin-right: 12px;
  flex: 0 0 auto;
  object-fit: cover;
}
.mp-name {
  font-size: 17px;
  font-weight: 600;
  color: var(--ink);
}
.mp-sub {
  font-size: 12.5px;
  color: var(--ink-faint);
  margin-top: 3px;
}
.mp-desc {
  font-size: 13.5px;
  line-height: 1.85;
  color: var(--ink-soft);
  margin: 0 0 14px;
  flex: 1 1 auto;
}
.mp-fans {
  font-size: 13px;
  color: var(--ink-soft);
}
.mp-fans strong {
  font-size: 19px;
  font-weight: 600;
  color: var(--accent);
  margin-right: 3px;
}
.mp-right {
  flex: 0 0 108px;
  text-align: center;
}
.mp-qr {
  cursor: zoom-in;
  width: 108px;
  height: 108px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: block;
}
.mp-qr-tip {
  font-size: 11.5px;
  color: var(--ink-faint);
  margin-top: 7px;
}
@media (max-width: 760px) {
  .mp-list {
    grid-template-columns: 1fr;
  }
  .mp {
    flex-direction: column;
  }
  .mp-left {
    padding-right: 0;
  }
  .mp-right {
    flex: 0 0 auto;
    text-align: left;
    margin-top: 16px;
  }
}
.story-link {
  display: inline-block;
  margin-top: 28px;
  font-size: 15px;
  font-weight: 500;
  color: var(--accent) !important;
}
.story-link:hover {
  color: var(--accent-deep) !important;
}
.chx-community {
  margin-top: 34px;
  padding-top: 28px;
  border-top: 1px solid var(--border);
}
.chx-intro {
  font-size: 15px;
  line-height: 2;
  color: var(--ink-soft);
  max-width: 720px;
  margin: 0 0 22px;
}
.chx-facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
}
.cf {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 20px;
}
.cf-value {
  font-size: 24px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.5px;
}
.cf-label {
  margin-top: 4px;
  font-size: 13px;
  color: var(--ink-faint);
}
</style>
